











import {Component, Vue} from "vue-property-decorator";

@Component({
  name: "testing-step-7",
})
export default class TestingStep7 extends Vue{
  mounted () {
    this.$emit('next-step-available');
  }
}
